import { foundationUrlInputStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX } from '../_common/colors.hex';
export const zeroUrlInputStyles = (context, definition) => css `
  ${foundationUrlInputStyles(context, definition)}
  a {
    color: ${PrimaryRapidColorHEX.blue};
    opacity: 65%;
  }

  a:hover {
    opacity: 100%;
  }
`;
